import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {ToolsService} from '../../services/tools.service';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarRatingComponent implements OnInit {
  @Input() ratingCustomClass: string;
  @Input() label: string;
  heartsArray: string[] = [];
  rateToDisplay: number;
  private rateValue: number;

  constructor(
    private tools: ToolsService,
    private _change: ChangeDetectorRef
  ) {}

  @Input() set rate(r: number) {
    this.initRating(r);
  }

  ngOnInit() {}

  public trackByFn(i: number, el: string) {
    return el ? `${i}-${el}` : null;
  }

  private initRating(r: number) {
    this.rateValue = r;
    if (this.tools.isNil(this.label) || this.label === '') {
      this.label = 'Snittbetyg';
    }
    this.rateToDisplay = this.tools.round(this.rateValue, 2);
    this.generateHeartsArray();
    this._change.markForCheck();
  }

  private generateHeartsArray() {
    this.heartsArray = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= this.rateValue) {
        this.heartsArray.push('star_filled');
      } else if (i > this.rateValue && i - 1 < this.rateValue) {
        this.heartsArray.push('star_half_filled');
      } else {
        this.heartsArray.push('star_outlined');
      }
    }
  }
}
